import { createContext, useContext } from 'react';

export const AuthContext = createContext({ user: null, loading: true, logout: () => {} });

export const useAuth = () => useContext(AuthContext);
